import React from "react";
import { withTranslation } from "react-i18next";
import { Accordion, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class EditCatalogDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        initValid: true,
        rule: value => ValidationHelper.isNonEmptyStringOfLength(value, 3, 50)
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isNonEmptyExtendedDescription
      },
      provider: {
        defaultValue: undefined,
        initValid: true,
        rule: value => ValidationHelper.isIntInRange(value, 0, 1)
      }
    };

    this.state = {
      dialogApiError: "",
      apiError: "",
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.options = [
      { value: 0, label: "CAMPLA" },
      { value: 1, label: "Chocolatey" }
    ];

    this.handleChange = this.handleChange.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: Object.assign(
        {},
        ValidationHelper.update(event, this.state.validation)
      )
    });
  }

  refreshValidation() {
    const validationDefinition = {
      name: {
        defaultValue: (" " + this.props.softwareCatalog?.name).substr(1),
        initValid: true,
        rule: value => ValidationHelper.isNonEmptyStringOfLength(value, 3, 50)
      },
      description: {
        defaultValue: Object.assign(
          {},
          this.props.softwareCatalog?.description
        ),
        initValid: true,
        rule: ValidationHelper.isNonEmptyExtendedDescription
      },
      provider: {
        defaultValue: 0 + this.props.softwareCatalog?.provider,
        initValid: true,
        rule: value => ValidationHelper.isIntInRange(value, 0, 1)
      }
    };
    this.setState({
      validation: ValidationHelper.getValidation(
        this.props.softwareCatalog
          ? validationDefinition
          : this.validationDefinition
      )
    });
  }

  componentDidMount() {
    this.refreshValidation();
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      await this.props.onUpdateCatalog(validatedData);
      this.refreshValidation();
      this.onHide();
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        title={t("SingleSoftwareCatalog.EditCatalogDialog.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonCallback={this.onHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        rightButtonCallback={this.onSubmit}
        rightButtonDisabled={!this.state.validation._isValid ||
          !ValidationHelper.hasChanged(this.state.validation) ||
          this.props.instanceTemplate?.isLocked
        }
        rightButtonText={t("SingleSoftwareCatalog.EditCatalogDialog.Form.Submit")}
        rightButtonVariant="green"
        body={(<Container className="pl-0 pr-0">
        {this.state.apiError ? (
          <Row>
            <Col>{this.state.apiError}</Col>
          </Row>
        ) : (
          ""
        )}
        <Form onSubmit={this.onSubmit}>
          <Accordion defaultActiveKey="0">
            <Card className="accordion-top-card">
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="0"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.name.isValid &&
                      this.state.validation.provider.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>
                    {t(
                      "SingleSoftwareCatalog.EditCatalogDialog.ToggleBasic"
                    )}
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form.Group controlId="formScriptName">
                    <Form.Label>
                      {t(
                        "SingleSoftwareCatalog.EditCatalogDialog.Form.Name"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder={t(
                        "SingleSoftwareCatalog.EditCatalogDialog.Form.NamePlaceholder"
                      )}
                      value={this.state.validation.name.value}
                      isInvalid={!this.state.validation.name.isValid}
                      onChange={this.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleSoftwareCatalog.EditCatalogDialog.Form.ValidationError.Name"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsPublished">
                    <Form.Label>
                      {t(
                        "SingleSoftwareCatalog.EditCatalogDialog.Form.Provider"
                      )}
                    </Form.Label>
                    <BaseSelect
                      menuPosition="fixed"
                      placeholder={t(
                        "SingleSoftwareCatalog.EditCatalogDialog.Form.ProviderPlaceholder"
                      )}
                      onChange={() => {
                      }}
                      isDisabled={true}
                      value={this.options
                        .filter(
                          o =>
                            o.value === this.state.validation.provider.value
                        )
                        .shift()}
                      options={this.options}
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.provider.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleSoftwareCatalog.EditCatalogDialog.Form.ValidationError.Provider"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          <Accordion defaultActiveKey="0">
            <Card className="accordion-mid-card">
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="1"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.description.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>
                    {t(
                      "SingleSoftwareCatalog.EditCatalogDialog.Form.Description"
                    )}
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <Form.Group>
                    <MarkDownEditor
                      defaultValue={this.props.softwareCatalog ?
                          this.props.softwareCatalog.description : ValidationHelper.getDefaultValueExtendedDescription()
                      }
                      onChange={value =>
                        this.handleChange({
                          target: {
                            name: "description",
                            value: value
                          }
                        })
                      }
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.description.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleSoftwareCatalog.EditCatalogDialog.Form.ValidationError.Description"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Form>
      </Container>)}
      />
    );
  }
}

export default withTranslation()(EditCatalogDialog);
